import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { getUserFromToken } from '../Components/Utils';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = () => {
      const token = Cookies.get('token');
      if (token) {
        try {
          const userData = getUserFromToken(token);
          setUser(userData);
        } catch (error) {
          Cookies.remove('token');
          setUser(null);
        }
      } else {
        setUser(null);
      }
    };

    loadUser();
    setLoading(false);
  }, []);

  useEffect(() => {
    const loadUser = () => {
      const token = Cookies.get('token');
      if (token) {
        try {
          const userData = getUserFromToken(token);
          setUser(userData);
        } catch (error) {
          setUser(null);
        }
      } else {
        setUser(null);
      }
    };

    window.addEventListener('storage', loadUser);
    const interval = setInterval(loadUser, 1000); // Poll for cookie changes
    return () => {
      window.removeEventListener('storage', loadUser);
      clearInterval(interval);
    };
  }, []);

  return (
    <UserContext.Provider value={{ user, loading, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within UserProvider');
  }
  return context;
};
